import './index.css'
import * as React from 'react'
import { Link } from 'react-router-dom'
type Props = {
  to: string
  children: React.ReactNode
}

// TODO: Needs a larger hit area, preferably a full row area
const DataTableLink = ({ to, children }: Props): React.ReactNode => (
  <Link className="DataTable_Link" to={to}>
    {children}
  </Link>
)

export default DataTableLink
